import { IUIChangeRecord } from '../interfaces/IUIChangeRecord';
import UIPropertyChange from '../models/UIPropertyChange';

export default class UIChangeRecord implements IUIChangeRecord {
    public FieldName = "";
    public PropertiesToChange: Array<UIPropertyChange> = new Array<UIPropertyChange>();
    public ReloadImage = false;
}  
